import type { FC } from 'react'

import { Tabs, TabsList, TabsTrigger } from '@/components/tabs/tabs'

import { type ResCategory } from '@/lib/queries/business/v1/types'

export interface CategoryTabsProps {
  value: string
  pathId: string
  tabs: ResCategory[]
  onChange: (val: string) => void
}

export const CategoryTabs: FC<CategoryTabsProps> = ({ value, pathId, tabs, onChange }) => {
  return (
    <Tabs
      value={value}
      onValueChange={(val) => {
        onChange(val)
      }}
    >
      <TabsList>
        <TabsTrigger className="text-faint-foreground" value={pathId}>
          All
        </TabsTrigger>
        {tabs.map((x) => (
          <TabsTrigger className="text-faint-foreground" value={String(x.id)} key={x.id}>
            {x.path_name}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}
